<template>
  <div>
    <div class="create-campaign-form">
      <div class="demo-alignment">
        <vs-breadcrumb class="mt-0"
        :items="items"
        separator=">>"
        ></vs-breadcrumb>
      </div>

      <div class="mt-5">
        <form-wizard ref="campaignWizard" color="rgba(var(--vs-primary), 1)" errorColor="rgba(var(--vs-primary), 1)" @on-change="currentTabChanged" :title="null" step-size="sm" :subtitle="null">
          <tab-content :title="$t('Campaign Objective & Type')" class="mb-5" :before-change="resolveStep1">
            <Step1 v-if="currentStep >= 1" v-model="form.step1" :formData="form" @reset-form="resetCampaignForm" ref="step1" :editing="editing" />

            <!-- Don't change the MobileWizardButtons hierarchy in the DOM tree -->
            <MobileWizardButtons :isLeadForm="form.step1.objective == 'Lead Form'" :currentStep="currentStep" />
          </tab-content>

          <tab-content :title="$t('Campaign Details')" class="mb-5" :before-change="resolveStep2">
            <div class="vx-row" v-if="currentStep >= 2">
              <!-- LEFT COL -->
              <div class="vx-col lg:w-3/4 w-full relative">
                <Step2 v-model="form.step2" ref="step2" :serverErrors="errors" :editing="editing" :objective="form.step1" />

                <!-- Don't change the MobileWizardButtons hierarchy in the DOM tree -->
                <MobileWizardButtons :isLeadForm="form.step1.objective == 'Lead Form'" :currentStep="currentStep" />
              </div>

              <!-- RIGHT COL -->
              <div class="vx-col lg:w-1/4 w-full">
                <CampaignSummary :form="form" :preview="['summary']"  :currentStep="currentStep" :advertising-channel="form.step1.advertisingChannelObject" />
              </div>
            </div>
          </tab-content>

          <tab-content :title="$t('Ad Set Targeting')" class="mb-5" :before-change="resolveStep3">
            <div class="vx-row" v-if="currentStep >= 3">
              <!-- LEFT COL -->
              <div class="vx-col lg:w-3/4 w-full relative">
                <Step3 v-model="form.step3" ref="step3" :advertising-channel="form.step1.advertisingChannelObject" :objective="form.step1.objective" :industry_id="form.step2.industry_id" :type="form.step1.type" :serverErrors="errors" :editing="editing" @passEstimationToRoot="setEstimation" @setActiveAdsetIndex="setActiveAdsetIndex" @adsetCountriesChanged="handleAdsetCountriesChanged" />

                <!-- Don't change the MobileWizardButtons hierarchy in the DOM tree -->
                <MobileWizardButtons :isLeadForm="form.step1.objective == 'Lead Form'" :currentStep="currentStep" />
              </div>

              <!-- RIGHT COL -->
              <div class="vx-col lg:w-1/4 w-full">
                <CampaignSummary :form="form" :preview="['summary', 'details']" :estimation="estimation" :currentStep="currentStep" :activeAdsetIndex="activeAdsetIndex" :advertising-channel="form.step1.advertisingChannelObject" />
              </div>
            </div>
          </tab-content>

          <tab-content :title="$t('Bidding')" class="mb-5" :before-change="resolveStep4">
            <div class="vx-row" v-if="currentStep >= 4">
              <!-- LEFT COL -->
              <div class="vx-col lg:w-3/4 w-full relative">
                <Step4
                  v-model="form.step3"
                  ref="step4"
                  :advertising-channel="form.step1.advertisingChannelObject"
                  :objective="form.step1.objective"
                  :objective-id="form.step1.objective_id"
                  :main-event="form.step2.main_event"
                  :type-id="form.step1.type_id"
                  :type="form.step1.type"
                  :industry="form.step2.industry_id"
                  :serverErrors="errors"
                  :budgetType="form.step2.no_end_date !== 'true' ? 'budget' : 'daily_budget'"
                  :editing="editing"
                  :endDate="form.step2.end_date || ''"
                  :startDate="form.step2.start_date || ''"
                  @setActiveAdsetIndex="setActiveAdsetIndex"
                  :changedAdsetCountries="changedAdsetCountries"
                />

                <!-- Don't change the MobileWizardButtons hierarchy in the DOM tree -->
                <MobileWizardButtons :isLeadForm="form.step1.objective == 'Lead Form'" :currentStep="currentStep" />
              </div>

              <!-- RIGHT COL -->
              <div class="vx-col lg:w-1/4 w-full">
                <CampaignSummary :form="form" :preview="['summary', 'details', 'adsets']" :currentStep="currentStep" :activeAdsetIndex="activeAdsetIndex" :advertising-channel="form.step1.advertisingChannelObject" />
              </div>
            </div>
          </tab-content>


          <tab-content :title="$t('Ads Customization')" class="mb-5" :before-change="resolveStep5">
            <div class="vx-row" v-if="currentStep >= 5">
              <!-- LEFT COL -->
              <div class="vx-col lg:w-3/4 w-full relative">
                <Step5 v-model="form.step3" ref="step5" :advertising-channel="form.step1.advertisingChannelObject" :objective="form.step1.objective" :objective-id="form.step1.objective_id" :type="form.step1.type" :serverErrors="errors" :editing="editing" />

                <!-- Don't change the MobileWizardButtons hierarchy in the DOM tree -->
                <MobileWizardButtons :isLeadForm="form.step1.objective == 'Lead Form'" :currentStep="currentStep" />
              </div>

              <!-- RIGHT COL -->
              <div class="vx-col lg:w-1/4 w-full">
                <CampaignSummary :form="form" :preview="['summary', 'details', 'adsets' , 'budget']" :currentStep="currentStep" :advertising-channel="form.step1.advertisingChannelObject" />
              </div>
            </div>
          </tab-content>

          <!-- lead form new step -->
          <tab-content v-if="form.step1.objective == 'Lead Form'" :title="$t('Lead Form')" class="mb-5" :before-change="resolveStep6">
            <div class="vx-row" v-if="currentStep >= 6">
              <!-- LEFT COL -->
              <div class="vx-col lg:w-3/4 w-full relative p-0">
                <Step6 v-model="form.step6" ref="step6" :serverErrors="errors" :editing="editing" />

                <!-- Don't change the MobileWizardButtons hierarchy in the DOM tree -->
                <MobileWizardButtons :isLeadForm="form.step1.objective == 'Lead Form'" :currentStep="currentStep" />
              </div>

              <!-- RIGHT COL -->
              <div class="vx-col lg:w-1/4 w-full">
                <CampaignSummary :form="form" :preview="['summary', 'details', 'adsets' , 'budget']" :currentStep="currentStep" :advertising-channel="form.step1.advertisingChannelObject" />
              </div>
            </div>
          </tab-content>

          <template slot="footer" slot-scope="props">
            <div class="hidden sm:block">
              <div class="back-xs-mobile-version wizard-footer-left">
                  <vs-button v-on:click="backButton()" id="create-campaign-back-button" v-if="props.activeTabIndex > 0" @click.native="back()" class="back-button-style w-40 back-button-border-radius back-button" color="" type="">
                    {{ $t('Back') }}
                  </vs-button>
              </div>

              <div class="next-xs-mobile-version" :class="{'text-center': props.activeTabIndex === 0, 'wizard-footer-left ml-5': props.activeTabIndex > 0}">
                <vs-button id="create-campaign-next-button" v-on:click="nextButton()" v-if="!props.isLastStep" @click.native="props.nextTab()" class="w-40 p-3 button-border-radius shadow-none" color="primary" type="filled">
                  {{ $t('Next') }}
                </vs-button>

                <wizard-button id="create-campaign-launch-button" v-else @click.native="submitCampaign(form.step1.objective == 'Lead Form' ? 'step6': 'step5')" class="w-40 p-3 button-border-radius shadow-none wizard-footer-right finish-button" :style="props.fillButtonStyle">
                  {{ $t('Launch') }}
                </wizard-button>
              </div>
            </div>
          </template>

        </form-wizard>
      </div>

      <speakol-response-popup
        v-on:hide-response-popup="stateModal.show = false"
        :responsePopupData="stateModal"
      />
    </div>
  </div>
</template>


<script>
import {
  FormWizard,
  WizardButton,
  TabContent
} from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'

import formatCampaignForForm from '@/views/campaigns/formatCampaignForForm.js'

import CampaignSummary from '@/views/campaigns/components/CampaignSummary.vue'
import MobileWizardButtons from '@/views/campaigns/components/MobileWizardButtons.vue'
import {cloneDeep} from 'lodash'

// Steps
import Step1 from '@/views/campaigns/components/steps/Step1.vue'
import Step2 from '@/views/campaigns/components/steps/Step2.vue'
import Step3 from '@/views/campaigns/components/steps/Step3.vue'
import Step4 from '@/views/campaigns/components/steps/Step4.vue'
import Step5 from '@/views/campaigns/components/steps/Step5.vue'
import Step6 from '@/views/campaigns/components/steps/Step6.vue'

import { objectToFormData } from '@/helpers/objectToFormData.js'
import FormSchema from '@/utils/LeadFormSchema'
import {filterFormQuestions} from '@/utils/filterFormQuestions.js'

export default {
  components: {
    FormWizard,
    WizardButton,
    TabContent,
    CampaignSummary,
    MobileWizardButtons,
    Step1,
    Step2,
    Step3,
    Step4,
    Step5,
    Step6
  },
  beforeRouteLeave (to, from, next) {
    if (this.avoidRouteLeave) {
      next()
      return
    }

    next(window.confirm('Do you really want to leave ? your campaign is not saved ! data will be lost !'))
  },

  async beforeCreate () {
    await this.$store.dispatch('campaign/getTargetingLookups')
  },

  data () {
    return {
      /**
       * Key for preventing multi form submitting
       */
      submitting: false,
      items:[
        {
          title: 'Campaigns',
          active: false
        },
        {
          title: 'Create Campaign',
          active: true
        }
      ],
      isValidating: false,
      currentStep: 1,
      avoidRouteLeave: false,
      editing: false,
      form: {
        step1: {
          advertisingChannelObject: {},
          advertisingChannel: '',
          objective: '',
          type: '',
          advertising_channel_id:0,
          objective_id: 0,
          type_id: 0
        },
        step2: {
          name: '',
          brand: '',
          industry_id: null,
          assignee_id: null,
          once_it_approved: 'true',
          no_end_date: 'true',
          start_date: null,
          end_date: null,
          main_event: null
        },
        step3: {
          advertising_channel_id: 0,
          adsets: []
        },
        step6: {
          form: {
            ...cloneDeep(FormSchema),
            properties: {
              primitive: filterFormQuestions(FormSchema.properties, false),
              custom: []
            }
          }
        }
      },
      stateModal: {
        type: 'error',
        show: false,
        body: 'Error message'
      },
      estimation: {},
      activeAdsetIndex: 0,
      changedAdsetCountries: {}
    }
  },
  async created () {
    if (this.$route.params.duplicate) {
      const response = await window.axios.get(`/campaigns/${this.$route.params.duplicate}`)

      if (response.data.payload.version !== 'v3') {
        alert('This campaign isn\'t applicable for editing in this dashboard version')
        return this.$router.go(-1)
      }

      this.form = formatCampaignForForm(response.data.payload, true)

      this.editing = true
    } else {
      this.form.step3.adsets.push(
        cloneDeep(this.$store.getters['campaign/defaultAdsetObject'])
      )
    }

    // clear old campaign, adset data
    window.initialCampaignData = {}
    this.$store.state.adsetsDomainsMinBidConfirmed = {}
  },
  methods: {
    nextButton () {
      if (this.currentStep === 1) {
        this.$gtag.event('Step1_Next')
      } else if (this.currentStep === 2) {
        this.$gtag.event('Step2_Next')
      } else if (this.currentStep === 3) {
        this.$gtag.event('Step3_Next')
      } else if (this.currentStep === 4) {
        this.$gtag.event('Step4_Next')
      } else if (this.currentStep === 5) {
        this.$gtag.event('Step5_Next')
      }
    },
    backButton () {
      if (this.currentStep === 2) {
        this.$gtag.event('Step2_Back')
      } else if (this.currentStep === 3) {
        this.$gtag.event('Step3_Back')
      } else if (this.currentStep === 4) {
        this.$gtag.event('Step4_Back')
      } else if (this.currentStep === 5) {
        this.$gtag.event('Step5_Back')
      } else if (this.currentStep === 6) {
        this.$gtag.event('Step6_Back')
      }
    },
    resolveStep1 () {
      return this.resolveStep()
    },
    resolveStep2 () {
      return this.resolveStep('step2')
    },
    resolveStep3 () {
      return this.resolveStep('step3')
    },
    resolveStep4 () {
      return this.resolveStep('step4')
    },
    resolveStep5 () {
      return this.resolveStep('step5')
    },
    resolveStep6 () {
      return this.resolveStep('step6')
    },
    resolveNextSuccess () {
      document.getElementById('scrollToTop').click()
    },
    currentTabChanged (prevIndex, nextIndex) {
      this.currentStep = nextIndex + 1
    },
    back () {
      this.$refs.campaignWizard.prevTab()
    },
    resetCampaignForm () {
      // reset the current step to unrender other steps
      this.currentStep = 1

      // reste the wizard it self
      this.$refs.campaignWizard.reset()

      // reset step 2 value
      this.form.step2 = {
        name: '',
        brand: '',
        industry_id: null,
        assignee_id: null,
        once_it_approved: 'true',
        no_end_date: 'true',
        start_date: (new Date).toISOString().split('T')[0],
        end_date: null,
        main_event: null
      }

      // reset the step 3 value
      this.form.step3.adsets = [cloneDeep(this.$store.getters['campaign/defaultAdsetObject'])]
    },
    /**
     * Resolves the step validation & performs the next action
     */
    resolveStep (stepRef = null) {
      return new Promise(async (resolve, reject) => {
        if (!window.navigator.onLine) {
          reject()
          this.$router.push('/offline')
          return
        }

        if (stepRef) {
          // after submitting data


          const $form = {}

          if (stepRef === 'step3') {
            $form[stepRef] = {
              advertising_channel_id: this.form.step1.advertising_channel_id,
              adsets: cloneDeep(this.form.step3.adsets).map((adset) => {
                adset.ads = []
                return adset
              })
            }
          } else if (stepRef === 'step4') {
            $form[stepRef] = {
              advertising_channel_id: this.form.step1.advertising_channel_id,
              adsets: cloneDeep(this.form.step3.adsets).map((adset) => {
                adset.ads = []
                adset.industry_id = this.form.step2.industry_id
                return adset
              })
            }
          } else if (stepRef === 'step5') {
            $form[stepRef] = {
              advertising_channel_id: this.form.step1.advertising_channel_id,
              adsets: cloneDeep(this.form.step3.adsets).map((adset) => {
                return {
                  ads: adset.ads
                }
              })
            }
          } else {
            $form[stepRef] = this.form[stepRef]
          }

          $form[stepRef].objective = this.form.step1.objective

          $form[stepRef].type = this.form.step1.type

          $form[stepRef].objective_id = this.form.step1.objective_id

          $form[stepRef].type_id = this.form.step1.type_id

          $form[stepRef].start_date = this.form.step2.start_date
          $form[stepRef].end_date = this.form.step2.end_date

          this.$root.$emit(`${stepRef}-resolved`)

          window.axios.post('/campaigns/wizard/partial/submit', objectToFormData($form)).then(() => {
            // clear errors
            this.$validator.errors.clear()

            this.resolveNextSuccess()
            resolve(true)

          }).catch(err => {
            if (err.response && err.response.data) {
              this.$setLaravelValidationErrorsFromResponse(err.response.data)
            }

            reject(err.message)
          })
        } else {
          this.resolveNextSuccess()
          resolve(true)
        }
      })
    },
    submitCampaign (step = 'step5') {
      this.resolveStep(step)
        .then(() => {
          if (this.submitting) {
            return
          }

          // start form submitting
          this.submitting = true

          const step1Campaign = this.form.step1
          delete step1Campaign.advertisingChannelObject

          this.form.step3.advertising_channel_id = this.form.step1.advertising_channel_id

          const $campaign = {
            step1: step1Campaign,
            step2: this.form.step2,
            step3: this.form.step3,
            step6: this.form.step6
          }

          window.axios.post('/campaigns/create', objectToFormData($campaign)).then(({ data }) => {
            this.avoidRouteLeave = true

            // save initial campaign data
            window.initialCampaignData = JSON.parse(JSON.stringify(data.payload))

            // this line to fetch the account data to update the status banner
            this.$store.dispatch('authentication/getUserAuth', localStorage.getItem('activeAccountId'))
            this.$router.push(`/campaigns/success/${data.payload.id}`)
            this.$gtag.event('Step5_Launch')

          }).catch(error => {
            const vErrors = []

            for (const e in error.response.data.errors) {
              if (error.response.data.errors.hasOwnProperty(e)) {
                const element = error.response.data.errors[e]
                element.forEach(err => {
                  vErrors.push(err)
                })
              }
            }

            this.stateModal = {
              type: 'error',
              show: true,
              body: vErrors.join('\n')
            }

            this.submitting = false
          })
        })
        .catch(e => {
          console.log(e)
        })
    },
    setEstimation (estimation) {
      this.estimation = estimation
    },
    setActiveAdsetIndex (activeAdsetIndex) {
      this.activeAdsetIndex = activeAdsetIndex
    },
    handleAdsetCountriesChanged (data) {
      this.changedAdsetCountries = data
    }
  }
}
</script>

<style lang="scss">
.create-campaign-form {
  .flatpickr-input {
    width: 100%;
  }

  .nav-tabs-navigation {
    margin-top: -14px;
  }

  // campagin details
  .vs-con-input,
  .input-select-con,
  .vue-treeselect {
    margin-top: 10px !important;
  }

  .vs-input--label,
  .vs-select--label,
  .input-label {
    font-weight: normal !important;
  }
  // .input-label {
  //   font-size: 16px !important;
  // }

  .vs-radio--circle {
    box-shadow: none !important;
  }

  // wizard
  .button-border-radius {
    border-radius: 4px !important;
    height: 42px !important;
  }

  .back-button-border-radius {
    border-radius: 4px !important;
    padding: 9px !important;
  }

  .vue-form-wizard.sm .wizard-navigation .wizard-progress-with-circle {
    left: 20px !important;
  }

  .wizard-nav .wizard-icon-circle.checked {
    background-color: rgba(var(--vs-primary), 1) !important;

    .wizard-icon {
      color: white !important;
    }
  }

  .wizard-nav .wizard-icon-container {
    background-color: white !important;

    .wizard-icon {
      color: #378ccb !important;
    }
  }

  .wizard-icon-container {
    border-radius: 100% !important;
  }

  .vue-form-wizard.sm .wizard-nav-pills > li.active > a .wizard-icon {
    color: #ccc !important;
  }

  @media (max-width: 576px) {
    ul.wizard-nav-pills li {
      display: none;
    }

    .wizard-progress-with-circle {
      display: none;
    }

    ul.wizard-nav-pills li.active {
      display: block;
    }
  }

  @media (max-width: 369px) {
    .next-xs-mobile-version {
      width: 100%;
      margin-left: 0 !important;
      margin-top: 15px;

      button {
        width: 100% !important;
      }
    }

    .back-xs-mobile-version {
      width: 100%;

      button {
        width: 100% !important;
      }
    }
  }

  ul.nav-tabs {
    display: inline-flex;
    width: 100% !important;
    overflow-x: scroll;
    overflow-y: hidden;
    position: relative;
    z-index: 1;
  }

  ul.nav-tabs > li > a > div > span {
    text-overflow: ellipsis !important;
    overflow: hidden !important;
    width: 20px !important;
    height: 1.2em !important;
    white-space: nowrap !important;
  }

  .nav-tabs::-webkit-scrollbar-track {
    border-radius: 10px !important;
    background-color: #f5f5f5 !important;
  }

  .nav-tabs::-webkit-scrollbar {
    height: 6px !important;
    background-color: #f5f5f5 !important;
  }

  .nav-tabs::-webkit-scrollbar-thumb {
    border-radius: 10px !important;
    background-color: lightgrey !important;
  }
}

.vs-breadcrumb--link {
  color: #378ccb !important;
  cursor: default;
  font-weight: 500 !important;
}

.vs-breadcrumb-text-primary {
  color: black !important;
  font-weight: 500 !important;
}

.separator {
  color: black;
  margin-top: -5px;
  font-weight: bold;
}

.back-button-style {
  color: rgba(var(--vs-primary), 1) !important;
  border: 1px solid rgba(var(--vs-primary), 1) !important;
}
</style>
